<template>
    <div class="card mx-auto">
        <div class="card-header bg-primary text-white">
            <page-title :title="($t(titleKey))" :icon="'fas fa-tags'"></page-title>
        </div>

        <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
            <div class="form-inline pl-2 col-lg-6 col-md-12">

            </div>

            <div class="input-group col-lg-6 col-md-12">
                <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                <button type="button" class="btn btn-secondary" @click.stop="massSearch">
                    <i class="fas fa-search"></i>
                    {{ $t('buttons.search.btnText') }}
                </button>
                <button type="button" class="btn btn-secondary"
                        @click.stop="clearFilters">
                    <i class="fas fa-times"></i>
                    {{ $t('buttons.clearFilters.btnText') }}
                </button>
            </div>
        </div>

        <div class="card-body">
            <kendo-datasource ref="datasource1"
                                :transport="transportSettings"
                                :schema-model-id="'id'"
                                :schema-model-fields="schemaModelFields"
                                :schema-total="'total'"
                                :schema-data="'data'"
                                :page-size='gridOptions.pageable.size'
                                :server-paging="true"
                                :server-sorting="true"
                                :server-filtering="true"
                                :error="dataSourceError"
                                :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="grid"
                id="grid"
                :data-source-ref="'datasource1'"
                :pageable="gridOptions.pageable"
                :navigatable="gridOptions.navigatable"
                :editable="gridOptions.editable"
                :filterable="gridOptions.filterable"
                :reorderable="gridOptions.reorderable"
                :resizable="gridOptions.resizable"
                :groupable="gridOptions.groupable"
                :allow-copy="gridOptions.allowCopy"
                :sortable-mode="gridOptions.sortable.mode"
                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                :column-menu="gridOptions.columnMenu"
                :selectable="gridOptions.selectable"
                :scrollable="gridOptions.scrollable"
                :data-bound="dataBound"
                v-on:detailinit="detailInit">
                <kendo-grid-column :field="'fieldName'"
                                    :title="$t('fieldCodes.gridHeaders.fieldName')">
                </kendo-grid-column>
                <kendo-grid-column :field="'code'"
                                    :title="$t('fieldCodes.gridHeaders.code')">
                </kendo-grid-column>
                <kendo-grid-column :field="'description'"
                                    :title="$t('fieldCodes.gridHeaders.description')">
                </kendo-grid-column>
                <kendo-grid-column :field="'isForDynamicForm'"
                                    :title="$t('fieldCodes.gridHeaders.isForDynamicForm')"
                                    :template="isForDynamicFormCellTemplate">
                </kendo-grid-column>
                <kendo-grid-column :command="['edit']"
                                   :title="$t('actions')">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { mapGetters } from 'vuex'
    import PageTitle from '../../../components/common/PageTitle';

    export default {
        components: { PageTitle },
        props: {},
        data() {
            return {
                componentName: "dynamicRegistersFieldCodes",
                titleKey: 'fieldCodes.title',
                searchQuery: '',
                schemaModelFields: {
                    id: {
                        name: "id",
                        type: "number",
                        editable: false,
                        nullable: false,
                        visible: false,
                    },
                    fieldName: {
                        name: 'fieldName',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                    },
                    code: {
                        name: 'code',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                    },
                    description: {
                        name: 'description',
                        type: 'string',
                        editable: true,
                        nullable: false,
                        visible: true,
                    },
                    isForDynamicForm: {
                        name: 'isForDynamicForm',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true
                    }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicFields/fieldCodes',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/dynamicFields/updateFieldCode',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.authToken) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.authToken);
                }
            },
            dataBound(ev) {
                ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
            },
            datasorceRequestEnd(e) {
                if (e.type === "update" && e.response) {
                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: this.$t('buttons.edit.btnText'),
                        text: this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('buttons.edit.btnText'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            isForDynamicFormCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isForDynamicForm ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isForDynamicForm ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            detailInit: function (e) {
                $('<div />').appendTo(e.detailCell).kendoGrid({
                    dataSource: {
                        transport: {
                            read: {
                                url: this.$store.getters.baseUrl + '/api/dynamicFields/fieldsWithFieldCode',
                                dataType: 'json',
                                type: 'POST',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            parameterMap: this.parameterMap
                        },
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true,
                        filter: { // това филтрира само елементите за дадена родителска категория
                            field: 'fieldCode',
                            operator: 'eq',
                            value: e.data.code
                        },
                        schema: {
                            model: {
                                id: 'id',
                                fields: {
                                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: false },
                                    fieldCode: { name: 'parentId', type: 'string', editable: false, nullable: false, visible: false },
                                    name: { name: 'name', type: 'string', editable: false, nullable: true, visible: true },
                                    nameEn: { name: 'nameEn', type: 'string', editable: false, nullable: true, visible: true },
                                    label: { name: 'label', type: 'string', editable: false, nullable: true, visible: true },
                                    labelEn: { name: 'labelEn', type: 'string', editable: false, nullable: true, visible: true },
                                    fieldType: { name: 'fieldType', type: 'string', editable: false, nullable: true, visible: true },
                                    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
                                    descriptionEn: { name: 'descriptionEn', type: 'string', editable: false, nullable: true, visible: true },
                                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: true, visible: true },
                                    usedIn: { name: 'usedIn', type: 'string', editable: false, nullable: true, visible: true },
                                    usedInEn: { name: 'usedInEn', type: 'string', editable: false, nullable: true, visible: true },
                                    formId: { name: 'formId', type: 'number', editable: false, nullable: true, visible: true },
                                }
                            },
                            total: 'total',
                            data: 'data'
                        },
                        error: this.dataSourceError,
                        requestEnd: this.datasorceRequestEnd,
                    },
                    editable: false,
                    pageable: this.gridOptions.pageable,
                    filterable: this.gridOptions.filterable,
                    reorderable: this.gridOptions.reorderable,
                    resizable: this.gridOptions.resizable,
                    scrollable: this.gridOptions.scrollable,
                    sortable: this.gridOptions.sortable,
                    columnMenu: this.gridOptions.columnMenu,
                    persistSelection: true,
                    toolbar: [],
                    columns: [
                        {
                            field: 'id',
                            title: this.$t('dinamicField.gridHeaders.id'),
                            hidden: true
                        },
                        {
                            field: 'name',
                            title: this.$t('dinamicField.gridHeaders.name'),
                            hidden: this.isEnVersion
                        },
                        {
                            field: 'nameEn',
                            title: this.$t('dinamicField.gridHeaders.name'),
                            hidden: !this.isEnVersion
                        },
                        {
                            field: 'label',
                            title: this.$t('dinamicField.gridHeaders.label'),
                            hidden: this.isEnVersion
                        },
                        {
                            field: 'labelEn',
                            title: this.$t('dinamicField.gridHeaders.label'),
                            hidden: !this.isEnVersion
                        },
                        {
                            field: 'fieldType',
                            title: this.$t('dinamicField.gridHeaders.fieldType')
                        },
                        {
                            field: 'description',
                            title: this.$t('dinamicField.gridHeaders.description'),
                            hidden: this.isEnVersion
                        },
                        {
                            field: 'descriptionEn',
                            title: this.$t('dinamicField.gridHeaders.label'),
                            hidden: !this.isEnVersion
                        },
                        {
                            field: 'usedIn',
                            title: this.$t('dinamicField.gridHeaders.usedIn'),
                            hidden: this.isEnVersion
                        },
                        {
                            field: 'usedInEn',
                            title: this.$t('dinamicField.gridHeaders.usedIn'),
                            hidden: !this.isEnVersion
                        },
                        {
                            field: 'formId',
                            title: this.$t('dinamicField.gridHeaders.formId')
                        },
                        ],
                })
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['gridOptions', 'authToken', 'claims', 'isEnVersion']),
            gridOptions() {
                return {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup', /* inline, popup */
                        window: {
                            title: this.$t('fieldCodes.title'),
                            animation: true
                        },
                        move: true
                    }
                };
            },
            hasEditRights() {
                return this.claims.dynamicRegister.update;
            },
        }
    }
</script>

<style scoped>
</style>
